import * as ActionsConstants from "../Constants/index";

const RestaurantServingStatuses = {
	OPEN: 1,
	CLOSED: 0,
	UNDER_REPLENISHMENT: 2,
	UNDER_MAINTENANCE: 3,
};

const RestaurantServingStatusesMap = {
	1: "OPEN",
	0: "CLOSED",
	2: "UNDER_REPLENISHMENT",
	3: "UNDER_MAINTENANCE",
};

const InitialState = {
	restaurant: {
		servingStatus: "",
	},
    RestaurantServingStatusesMap,
    RestaurantServingStatuses
};

export const foodmaking = (state = InitialState, action) => {
	switch (action.type) {
		case ActionsConstants.SET_RESTAURANT_DATA:
			return {
				...state,
				restaurant: {
					...action.data,
				},
			};

		default:
			return {
				...state,
			};
	}
};

export default foodmaking;
